{
  "tableConfig": {
    "columns": [
      {
        "fieldName": "jobOrderNo",
        "displayName": "Job Order No",
        "dataType": "STRING",
        "sortable": false
      },
      {
        "fieldName": "jobOrderTypeLabel",
        "displayName": "Job Order Type",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "140px"
        },
        "valueMap": {
          "Custom Service": "Special Service"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "display": "flex",
            "padding": "2px 8px",
            "align-items": "center",
            "border-radius": "16px",
            "font-size": "12px",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center"
          },
          "conditions": [
            {
              "expression": "eq(value, 'Seal Cut & Examination')",
              "styleProperties": {
                "border": "1px solid var(--Blue-light-200, #B9E6FE)",
                "background": "var(--Blue-light-50, #F0F9FF)",
                "color": "var(--Blue-light-700, #026AA2)"
              }
            },
            {
              "expression": "eq(value, 'RMS & Examination')",
              "styleProperties": {
                "border": "1px solid var(--Blue-light-200, #B2DDFF)",
                "background": "var(--Blue-light-50, #EFF8FF)",
                "color": "var(--Blue-light-700, #175CD3)"
              }
            },

            {
              "expression": "eq(value, 'RMS Seal Verification')",
              "styleProperties": {
                "border": "1px solid var(--Purple-200, #D9D6FE)",
                "background": "var(--Purple-25, #FAFAFF)",
                "color": "var(--Purple-600, #6938EF)"
              }
            },
            {
              "expression": "eq(value, 'Factory Delivery')",
              "styleProperties": {
                "border": "1px solid var(--Success-200, #ABEFC6)",
                "background": "var(--Success-50, #ECFDF3)",
                "color": "var(--Success-700, #067647)"
              }
            },
            {
              "expression": "eq(value, 'Destuff Delivery')",
              "styleProperties": {
                "border": "1px solid var(--Orange-200, #F9DBAF)",
                "background": "var(--Orange-50, #FEF6EE)",
                "color": "var(--Orange-700, #B93815)"
              }
            },
            {
              "expression": "eq(value, 'LCL Destuff')",
              "styleProperties": {
                "border": "1px solid var(--Gray-blue-200, #D5D9EB)",
                "background": "var(--Gray-blue-50, #F8F9FC)",
                "color": "var(--Gray-blue-700, #363F72)"
              }
            },
            {
              "expression": "eq(value, 'LCL Delivery')",
              "styleProperties": {
                "border": "1px solid var(--Error-200, #FEDF89)",
                "background": "var(--Error-50, #FFFAEB)",
                "color": "var(--Error-700, #DC6803)"
              }
            },
            {
              "expression": "eq(value, 'Hub Truck Movement')",
              "styleProperties": {
                "border": "1px solid var(--Purple-200, #99F6E0)",
                "background": "var(--Purple-50, #F0FDF9)",
                "color": "var(--Purple-700, #107569)"
              }
            },
            {
              "expression": "eq(value, 'Hub Stuffing')",
              "styleProperties": {
                "border": "1px solid var(--Brand-200, #BFDBF8)",
                "background": "var(--Brand-50, #F1F7FE)",
                "color": "var(--Brand-700, #0E4E96)"
              }
            },
            {
              "expression": "eq(value, 'Hub Container Delivery')",
              "styleProperties": {
                "border": "1px solid var(--Indigo-200, #C7D7FE)",
                "background": "var(--Indigo-50, #EEF4FF)",
                "color": "var(--Indigo-700, #3538CD)"
              }
            },
            {
              "expression": "eq(value, 'Custom Service')",
              "styleProperties": {
                "border": "1px solid #B3B8DB",
                "background": "#EAECF5;",
                "color": "#363F72"
              }
            }
          ]
        }
      },

      {
        "fieldName": "issueDate",
        "displayName": "Issue Date",
        "dataType": "DATETIME",
        "sortable": true
      },
      {
        "fieldName": "expiryDate",
        "displayName": "Expiry Date",
        "dataType": "DATETIME",
        "sortable": true
      },
      {
        "fieldName": "jobOrderStatusLabel",
        "displayName": "Status",
        "dataType": "STRING",
        "thStyleConfig": {
          "width": "70px"
        },
        "styleConfig": {
          "type": "badge",
          "styleProperties": {
            "display": "flex",
            "padding": "2px 6px",
            "align-items": "center",
            "gap": "4px",
            "border-radius": "6px",
            "box-shadow": "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
            "font-family": "Inter",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "500",
            "line-height": "18px",
            "text-align": "center"
          },
          "conditions": [
            {
              "expression": "eq(value, 'Completed')",
              "styleProperties": {
                "border": "1px solid var(--Success-200, #ABEFC6)",
                "background": "var(--Success-50, #ECFDF3)",
                "color": "var(--Gray-900, #101828)"
              }
            },
            {
              "expression": "eq(value, 'Cancelled')",
              "styleProperties": {
                "border": "1px solid var(--Error-300, #FDA29B)",
                "background": "var(--Error-50, #FEF3F2)",
                "color": "var(--Gray-900, #101828)"
              }
            },
            {
              "expression": "eq(value, 'Expired')",
              "styleProperties": {
                "border": "1px solid var(--Gray-300, #D0D5DD)",
                "background": "var(--Gray-100, #F2F4F7)",
                "color": "var(--Gray-900, #101828)"
              }
            },
            {
              "expression": "eq(value, 'Pending')",
              "styleProperties": {
                "border": "1px solid var(--Warning-200, #FEDF89)",
                "background": "var(--Warning-50, #FFFAEB)",
                "color": "var(--Gray-900, #101828)"
              }
            }
          ]
        }
      },

      {
        "fieldName": "createdBy",
        "displayName": "Created By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedBy",
        "displayName": "Modified By",
        "dataType": "STRING",
        "styleConfig": {
          "type": "user-avatar"
        }
      },
      {
        "fieldName": "modifiedDate",
        "displayName": "Modified At",
        "dataType": "DATETIME",
        "sortable": true
      }
    ]
  },

  "filterConfig": {
    "filterFields": [
    {
      "name": "JOB_ORDER_NO_CONTAINS",
      "displayLabel": "Job Order No",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "JOB_ORDER_NO_CONTAINS"
      }
    },    {
      "name": "INVENTORY_NO_CONTAINS",
      "displayLabel": "Inventory No",
      "dataType": "STRING",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "INVENTORY_NO_CONTAINS"
      }
    },    {
      "name": "JOB_ORDER_TYPE_EQUALS",
      "displayLabel": "Job Order Type",
      "dataType": "DROPDOWN",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "JOB_ORDER_TYPE_EQUALS"
      }
    },    {
      "name": "JOB_ORDER_STATUS_EQUALS",
      "displayLabel": "Job Order Status",
      "dataType": "DROPDOWN",
      "supportedOperators": ["EQ"],
      "operatorToFilterMap": {
        "EQ": "JOB_ORDER_STATUS_EQUALS"
      }
    }
  ],
      "useNewContract": true

},
  "searchBarConfig": {
    "placeHolder": "Search Job",
    "filters": [
      {
        "name": "JOB_ORDER_NO_CONTAINS",
        "alias": "job"
      }
    ]
  },
  "viewConfig": {
    "viewOptions": [
      {
        "id": "IMPORT",
        "name": "Import",
        "filters": [
          {
            "name": "PROCESS_CYCLE_EQUALS",
            "alias": "processCycle",
            "operator": "IS_NULL",
            "value": ["IMPORT"]
          }
        ]
      },
      {
        "id": "EXPORT",
        "name": "Export",
        "filters": [
          {
            "name": "PROCESS_CYCLE_EQUALS",
            "alias": "processCycle",
            "operator": "IS_NULL",
            "value": ["EXPORT"]
          }
        ]
      }
    ]
  }
}
